import { Row, Col, Image } from 'antd';
import { config } from '../../../config';
import { useTranslation, withTranslation } from 'react-i18next';
import React from 'react';
import { ResponsiveContainer, Typography } from '@sunday/component';
import styles from './home-product.module.scss';
import highlightData from './home-product.json';

const { ASSET_PREFIX } = config;
const HomePageProductNameSpace = ['component.home.product'];

export const HomeProduct = () => {
const { t } = useTranslation(HomePageProductNameSpace);
  return (
    <div className={styles.container} id="products">
      <ResponsiveContainer className={styles.content}>
        <Row justify="center">
          <Col xl={6} sm={6} xs={0}>
            <Typography.Display designLevel={3} weight='bold' className={styles.title} >
              {t('title')}
            </Typography.Display>
            <Typography.Title designLevel={3} >
              {t('body')}
            </Typography.Title>
          </Col>
          <Col xl={0} xs={24}>
            <Typography.Headline designLevel={1} weight='bold' className={styles.title} >
              {t('title')}
            </Typography.Headline>
            <Typography.Body designLevel={1} >
              {t('body')}
            </Typography.Body>
          </Col>
          <Col xl={18} xs={0} >
            <Row justify={"center"}>
              {highlightData.map((item: any, index: number) => (
                <Col key={`product-${index+1}`} className={styles.products}>
                  <Image
                    preview={false}
                    alt={item.altImg}
                    src={`${ASSET_PREFIX}/static/img/${item.fileName}`}
                    style={{marginBottom: "40px"}}
                  />
                  <Typography.Headline designLevel={2} weight='bold'>
                    {t(`products.item-${index+1}.title`)}
                  </Typography.Headline>
                  <Typography.Body designLevel={2} >
                  {t(`products.item-${index+1}.body`)}
                  </Typography.Body>
                </Col>
              ))}
            </Row>
          </Col>
          <Col xl={0} xs={24} >
            <Row justify={"center"}>
              {highlightData.map((item: any, index: number) => (
                <Col key={`product-${index+1}`} className={styles.products}>
                  <Image
                    preview={false}
                    alt={item.altImg}
                    src={`${ASSET_PREFIX}/static/img/${item.fileName}`}
                    style={{marginBottom: "40px"}}
                  />
                  <Typography.Headline designLevel={3} weight='bold'>
                    {t(`products.item-${index+1}.title`)}
                  </Typography.Headline>
                  <Typography.Body designLevel={3} >
                  {t(`products.item-${index+1}.body`)}
                  </Typography.Body>
                </Col>
              ))}
            </Row>
          </Col>
        </Row>
      </ResponsiveContainer>
    </div>
  );
};

export default withTranslation('page.home')(HomeProduct);
